import { stringifyUrlQuery } from 'helpers';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type {
  GetOrganisationUsersRequestType,
  GetOrganisationUsersResponseType,
} from '../types';

export const getOrganisationUsers = async ({
  pathParams: { organisationId },
  queryParams: { email, isAdmin, isDeleted, nameAndSurname, page, perPage },
}: GetOrganisationUsersRequestType) => {
  const query = stringifyUrlQuery({
    email,
    isAdmin,
    isDeleted,
    nameAndSurname,
    page,
    perPage,
  });

  const url = `/api/v2/organisations/${organisationId}/users${query}`;

  const { data } =
    await apiAuthClient.get<GetOrganisationUsersResponseType>(url);

  return data;
};
